import { createContext, useContext } from 'react';
import { DEFAULT_SUBJECT_ID, EnrolledSubject, Subject, SubjectId, SubjectsPayload } from './types';

export interface SubjectContextValue {
  payload: SubjectsPayload | null;
  activeId: SubjectId;
  active: EnrolledSubject | null;
  visible: EnrolledSubject[];
  hidden: EnrolledSubject[];
  catalogue: Subject[];
  switchSubject: (id: SubjectId) => void;
  addSubject: (id: SubjectId) => Promise<void>;
  setHidden: (id: SubjectId, hidden: boolean) => Promise<void>;
  refresh: () => Promise<void>;
}

export const SubjectContext = createContext<SubjectContextValue | null>(null);

/** The active subject id, or the default when rendered outside a SubjectProvider. */
export const useActiveSubjectId = (): SubjectId => useContext(SubjectContext)?.activeId ?? DEFAULT_SUBJECT_ID;
